import { handleActions } from 'redux-actions';
import { Actions, getRolesRequest, getRolesSuccess, getRolesFailure } from 'actions/roleActions';
import { Role, RoleId } from 'shared/models';

export type State = Readonly<{
    data: Record<RoleId, Role>;
    loading: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: false,
    error: null,
});

export const rolesReducer = handleActions({
    [Actions.GET_ROLES_REQUEST]: (state: State, action: ReturnType<typeof getRolesRequest>) => {
        return {
            ...state,
            loading: true,
        };
    },
    [Actions.GET_ROLES_SUCCESS]: (state: State, action: ReturnType<typeof getRolesSuccess>) => {
        const data = action.payload;
        return {
            ...state,
            data,
            loading: false,
            error: null,
        };
    },
    [Actions.GET_ROLES_FAILURE]: (state: State, action: ReturnType<typeof getRolesFailure>) => {
        const error = action.payload;
        return {
            ...state,
            loading: false,
            error,
        };
    },
} as any, initialState);
